import '../css/landing.css';
import image1 from '../assets/mehabere.jpg'; 
import image2 from '../assets/landingpages.jpg';

export default function Landing() {
    return (
        <div className="landing">
            <div className="image-section">
                <div className="image-card">
                    <img src={image1} alt="Image 1" className="image"/>
                    <div className="image-description">
                        <h3>ምስል አምባሳች</h3>
                        <p>
                            በአማካይ አንድ ምስል እና በሌላ ምንባር ማቅረብ ከሆነ ምስል ሲመጣ የምስል እና የማኅበሩ አላማ አንድ ምስል በማዕከላዊ አይነት እንዲቀርበዋቸው እንደ ምስል ማቅረብ ሲመጣ።
                        </p>
                    </div>
                </div>
                <div className="image-card">
                    <img src={image2} alt="Image 2" className="image"/>
                    <div className="image-description">
                        <h3>አማራጭ ምስል ትምህርት</h3>
                        <p>
                            በምስል እንዲሁም በተለያዩ ምንባር የተሰረቀ ውስብስ በምስል ውስጥ ማህበሩ የተቋቋመበት አላማን እንደ ምስል እና በማኅበሩ ባለምድረ-በረከት ማሰብ ተመሰረተ።
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
